import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { AgendamientoResumido } from "../../../services/agendamientosServicios";
import { formatearTiempoStr } from "../../../utils/dateUtils";
import ServicioBadge from "../../organisms/ServicioBadge";

function AgendamientosTable({
  agendamientos,
  onAgendamientoClick,
}: {
  agendamientos: AgendamientoResumido[];
  onAgendamientoClick: (agendamiento: AgendamientoResumido) => void;
}) {
  if (!agendamientos || agendamientos.length === 0) {
    return <></>;
  }
  return (
    <>
      <StyledTable responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Mascota</StyledColHeader>
            <StyledColHeader>Fecha</StyledColHeader>
            <StyledColHeader>Servicio</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {agendamientos.map((a) => (
            <TableItem
              key={a.id}
              agendamiento={a}
              onAgendamientoClick={onAgendamientoClick}
            />
          ))}
        </tbody>
      </StyledTable>
    </>
  );
}

function TableItem({
  agendamiento,
  onAgendamientoClick,
}: {
  agendamiento: AgendamientoResumido;
  onAgendamientoClick: (agendamiento: AgendamientoResumido) => void;
}) {
  return (
    <StyledRow
      onClick={() => {
        onAgendamientoClick(agendamiento);
      }}
    >
      <StyledCell>{agendamiento.mascota}</StyledCell>
      <StyledCell>
        {formatearTiempoStr(agendamiento.fechaAgendamiento)}
      </StyledCell>
      <StyledCell>
        {<ServicioBadge servicio={agendamiento.tipoServicio} />}
      </StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default AgendamientosTable;
